<template>
  <div class="menus-wrap">
    <!-- <div>
      <button @click.prevent="addMenu">Add Menu</button>
      <button @click.prevent="saveAllMenus">Save</button>
      <button @click.prevent="clearAllChanges">Clear All Changes</button>
      <button @click.prevent="printMenu">Print Menu</button>
    </div> -->


    <h1 v-if="!Number(wpData.togo)" class="header" v-html="headerTitle"></h1>
    <transition name="fade" mode="out-in">

      <div class="menus" v-if="wpMenus.length">
      <!-- <draggable
        v-if="menus.length"
        v-model="menus"
        class="menus"
        :options="{draggable:'.menu'}"
        @start="drag=true"
        @end="menuDragEnd"
        :component-data="getComponentData()"
      > -->

        <template
          v-for="(menu, menu_index) in wpMenus"
        >
          <drinks-menu
            v-if="menu.acf.is_drinks_menu"
            :menu.sync="menu"
            :numMenus="menus.length"
            :menuOrder="menu_index"
            :location="location"
            :key="menu.id"
            @removeMenu="removeMenu"
            @resizeComplete="resizesCompleted++"
          />
          <menu-block
            v-else
            :menu.sync="menu"
            :numMenus="menus.length"
            :location="location"          
            :menuOrder="menu_index"
            :key="menu.id"
            @removeMenu="removeMenu"
            @resizeComplete="resizesCompleted++"
          />
          
        </template>

      <!-- </draggable> -->
      </div> <!-- .menus -->
      <div v-else-if="noMenusFound">
        <h3>Couldn't find any menus for this location.</h3>
      </div>
      <v-spinner v-else
        class="spinner--wrap"
        message="Loading Our Menus"
        :font-size="15"
        :spacing="15"
        :lineSize="5"
        line-fg-color="#fb8b13"      
        line-bg-color="#ffc43d"      
      />
    </transition>

    <!-- <div>
      <button @click.prevent="addMenu">Add Menu</button>
      <button @click.prevent="saveAllMenus">Save</button>
      <button @click.prevent="clearAllChanges">Clear All Changes</button>
      <button @click.prevent="printMenu">Print Menu</button>
    </div> -->

  </div>
</template>

<script>

import _ from 'lodash'
import axios from 'axios'

import { mapState } from 'vuex'
  
import draggable from 'vuedraggable'
import EditableTextField from '../EditableTextField'
import DrinksMenu from '../Menus/DrinksMenu'
import MenuBlock from '../Menus/MenuBlock'
import LocationMeta from './LocationMeta'

import VSpinner from 'vue-simple-spinner'

const testDrinksMenu = require('../testDrinksMenu.js')
const testMenusData = require('../testMenusData.js')

export default {

  name: 'LocationMenus',
  components : {
    draggable,
    'menu-block' : MenuBlock,
    'drinks-menu' : DrinksMenu,
    'editable-text' : EditableTextField,
    'location-meta' : LocationMeta,
    'v-spinner' : VSpinner    
  },
  props : {
    'postType' : {
      type: String,
      required: false,
      default : 'satsuma_menu_blocks'
    },
    'location' : {
      type: Object,
      required: true
    },
    'isEditable' : Boolean
  },

  data () {
    return {
      apiResponse : '',
      locations : [],
      wpMenus : [],
      newMenus : [],
      menu_order : 0,
      originalData : [],
      authToken : null,
      noMenusFound : false,
      resizesCompleted : 0
    }
  },
  computed: {
    ...mapState(['menus','wpData', 'menuBoard']),
    _() {
      return _;
    },
    headerTitle() {
      if ( Number(this.wpData.togo) ) { return 'Togo Menu' }
      if (this.menuBoard) { return 'Menu Board - ' + this.menuBoard.title.rendered }
      else if( this.location ) { return 'Location - ' + this.location.title.rendered }
    }, // headerTitle

  },
  async mounted() {
    // let locations = await this.getPosts('satsuma_locations', 'locations');
    // this.$store.commit('setLocations', locations)

    let menus;
    if( !!this.wpData.menuBlocks ) {
      menus = wpData.menuBlocks;
    } else {
      menus = await this.getMenus();
    }
    this.wpMenus = menus;
    if( !this.wpMenus.length ) {
      this.noMenusFound = true;
    }

    // this.$store.commit('setMenus', menus)
    // this.$store.commit('setMenus', testMenusData)
  },
  methods : {
    menuDragEnd( event ){
      debugger;
      // if( event.moved ) {
        // let menu = event.moved.element;
        this.wpMenus[ event.newIndex ].menu_order = event.oldIndex;
      // }
    },//onMenuListChange

    getComponentData() {
      return {
        // on: {
        //   change: () => {
        //     console.log('changed', this);
        //   },
        // }
      }
    }, // getComponentData()

    objIsEditable( obj ) {
      return obj.editable && !obj.disabled;
    }, // objIsEditable()

    toggleEditMode( post ) {
      this.setMenuProp( post, 'editable', !post.editable);
    }, // toggleEditMode

    enableEditMode( post ) {
      this.setMenuProp( post, 'editable', true);
    }, // enableEditMode

    disableEditMode( post ) {
      this.setMenuProp( post, 'editable', false);
    },

    enableMetaEdit( location ) {
      this.setMetaProp( location, 'editable', true);
    }, // enableMetaEdit

    disableMetaEdit( location ) {
      this.setMetaProp( location, 'editable', false);
    }, // disableMetaEdit

    addMenu() {
      this.$store.commit('addMenu');
    }, // addMenu

    removeMenu( menu_id ) {
      this.$store.commit('removeMenu', menu_id);
    }, // removeMenu


    async getMenus() {
      if( !this.wpData.menu_ids.length ) {
        console.log('No menu ids to include');
        return [];
      }

      let includeString = this.wpData.menu_ids.map( v => { return `include[]=${v}` }).join('&')
      const response = await axios( `${this.wpData.rest_url}/wp/v2/${this.wpData.cpts.menuBlocks}?${includeString}` )

      let menus = response.data;//_.sortBy( response, post => { return post.menu_order });
      this.originalData = _.clone(menus); 

      // This sort array will determine which menus
      // get shown. if it's empty, nothing shows
      let sortArray = [];

      // If this view is NOT togo menu and it's a menuBoard,
      // assign the menuBoard menu_ids from ACF to sortArray
      if( !Number( this.wpData.togo ) && this.menuBoard ) {
        sortArray = this.menuBoard.acf.menu_ids
      // If this view is a togo menu and there is location specified,
      // assign the location's menu obj from ACF to sortArray
      } else if( Number( this.wpData.togo ) && this.location ) {
        sortArray = this.location.acf.location_menus
      }

      let sortedMenus = [];
      _.each( sortArray, (id) => {
        let filteredMenus = menus.filter( menu => menu.id == id )[0];
        if( !_.isUndefined(filteredMenus) ) {
          sortedMenus.push( filteredMenus )
        }
      })
      return sortedMenus;
    }, // getMenus

    saveAllMenus() {
      this.$notify('Updating..');

      this.authPromise().then( authRes => {
        this.authToken = authRes.data.token;        

        let axiosPromises = this.buildAllMenuPromises();
        
        axios.all(axiosPromises).then( axios.spread( ()=> {
          this.$notify('Done with promises');
        }))

      });

    }, // saveAllMenus()

    buildSingleMenuPromises( menu, menu_index ) {
      let promises = [];

      var axiosCall;
      this.menu_order = menu_index;

      axiosCall = !menu.new? this.updateMenuPost( menu ) : this.newMenuPost( menu );
      promises.push(axiosCall);

      return promises;
    }, // buildSingleMenuPromises()

    buildAllMenuPromises() {
      let promises = [];

      _.each( this.wpMenus, (post, i) => {
          var axiosCall;
          this.menu_order = i;

          axiosCall = !post.new? this.updateMenuPost( post ) : this.newMenuPost( post );
          promises.push(axiosCall);
      });
      return promises;
    }, // buildAllMenuPromises()


    clearAllChanges() {
      this.wpMenus = this.originalData;
    }, // clearAllChanges

    async printMenu() {
      const browser = await puppeteer.launch();

      const page = await browser.newPage();
      await page.goto('http://clients.madebycaliper.com/satsuma', {waitUntil: 'networkidle2'} );
      // await page.goto('http://satsumawp.test/satsuma', {waitUntil: 'networkidle2'} );
      await delay(15000);
      let dom = await page.$eval('.menus-wrap', (element) => {
           return element.innerHTML
      }) // Get DOM HTML
  
      const styles = await page.$$eval('link[rel=stylesheet]', (element) => {
        return element;
      }) // Get style tags
      

      let parentFontsHref = await page.$eval('#twentyseventeen-fonts-css', el => el.href);      
      let parentStyleHref = await page.$eval('#parent-style-css', el => el.href);      
       
      console.log('[Stylesheets]')
      console.log(styles)

      await page.setContent(dom)   // HTML markup to assign to the page for generate pdf
      await page.addStyleTag({url:parentFontsHref});
      await page.addStyleTag({url:parentStyleHref});
      await page.addStyleTag({url:'https://fonts.googleapis.com/css?family=Jaldi:400,700'});

      let options = {
        format : 'legal',
        landscape: true,
        path : 'menu.pdf'
      }
      await page.pdf(options)

      await browser.close();

      function delay(time) {
         return new Promise(function(resolve) { 
             setTimeout(resolve, time)
         });
      }

    }, // printMenu

    setMenuProp(post, key, val) {
      let post_id = post.id;

      // Update the menu item by cloning and modifying it,
      // then splicing the wpMenus obj
      let index = _.findIndex(this.wpMenus, function(post) { return post.id == post_id });
      let tmpMenu = _.clone(this.wpMenus[ index ]);
      tmpMenu[ key ] = val;
      this.wpMenus.splice( index, 1, tmpMenu );
      
    }, // setMenuProp

    setMetaProp(location, key, val) {
      this.location[ key ] = val;
      return false;
      // short circuit for now. not using an array of locations yet

      let post_id = location.id;

      // Update the menu item by cloning and modifying it,
      // then splicing the wpMenus obj
      let index = _.findIndex(this.locations, function(post) { return location.id == post_id });
      let tmpLoc = _.clone(this.locations[ index ]);
      tmpLoc[ key ] = val;
      this.locations.splice( index, 1, tmpLoc );
      
    }, // setMetaProp

  }, // methods
  watch : {
    resizesCompleted(newVal) {
      if( newVal == this.wpMenus.length ) {
        this.$store.commit('setPuppeteerReady')
      }
    }, // resizesCompleted

  }, // watch
}
</script>

<style lang="scss">

body.togo-body {
  margin:0;
  #menu-manager-app {
    justify-content:left;
  }
}

.menus-wrap {
  // width:80%;
  max-width:1680px;
  margin:auto;
}

ul {
  list-style:none;
  padding:0;
  margin:0;
}


button {
  cursor:pointer;
  transition: background-color .3s ease;  
  background-color:#34bd34;
  border:0;
  color:white;
  font-size:0.7rem;
  padding:7px 10px;
  text-transform:uppercase;
  display:inline-flex;
  align-items:center;
  // position:absolute;
  // transform:translateX(-110%);

  &:hover {
    background-color:#319831;    
  }
}


/*=========================================
=            Menu Block Styles           =
=========================================*/
// These are shared between MenuBlock and DrinksMenu
// and DrinksMenu must have access to them at all times
// even if a MenuBlock isn't present on the page (which
// in Vue world means they wont get loaded)




.menus {
  display:flex;
  flex-wrap:wrap;
  @media (max-width:768px) {
    padding-top:40px;
    padding-bottom:40px;
  }
}

.menu-inner {
  width: 100%;
  position: relative;
  display:flex;
  align-items:stretch;
  flex-wrap:wrap;
  justify-content:space-between;
}



$gutter:20px;

.meta-page {
  text-align:center;
  padding:100px 40px;
}

$borderWidth : 2px;

@mixin bgPseudoElem {
  cursor:pointer;
  &:before {
    transition: border-color .5s ease;
    content : '';
    position:absolute;
    z-index:-1;
    height:calc(100% - #{$borderWidth*2});
    width:calc(100% - #{$borderWidth*2});
    right:0;
    top:0px;
    border:$borderWidth solid transparent;
    // border-bottom:2px solid #DDD;
    // background-color:white;
  }  
}

@mixin hoverElem {
  &:before {
    border-color:rgba(138, 251, 109, 0.6);
  }
}


.menus .menu {
  // transition: background-color .3s ease, opacity .3s ease, box-shadow .3s ease, position .3s ease;
  transition: all .3s ease;
  box-shadow:none;
  // background-color:white;  
  opacity:1;
  position: relative;
  display:flex;
  align-items:stretch;
  padding:0 $gutter/2;

  @media (min-width:768px) {
    padding:$gutter*2 $gutter;
  }
  @media (min-width:#{640px + ($gutter*2)}) {
    flex:1 0 calc(50% - #{($gutter*2)});
    min-width:640px;
  }

  &.selected:not(.ui-hidden) {
    // box-shadow:0 7px 22px -4px rgba(0, 0, 0, 0.3), inset 0px 0px 0px 1px rgba(0,0,0,0.1);
    box-shadow:0 7px 22px -4px rgba(#37c120, 0.3), inset 0px 0px 0px 1px rgba(0,0,0,0.1);
    transform: translateY(-5px);
    z-index:1000;
    background-color:white;
    .section, .item, .addon {
      transition: background-color .3s ease;      
      &:hover {
        // box-shadow:0 7px 24px -2px rgba(0, 0, 0, 0.5)
        // background-color:rgba(0,0,0,.1);
      }
    }
    > .button-cluster {
      display:flex;
    }

  }

  // @include bgPseudoElem;
  &:not(.selected) {
    &:hover {
      // @include hoverElem;
      > .button-cluster {
        display:flex;
      }


    }
  }

  &.disabled {
    opacity:.2;
  }

  &.dragging {
    .empty{
      align-self: stretch;
      &:after {
        background-color:rgba(black, .05);
        content:'';
        position:absolute;
        $padding:10px;
        padding:$padding;
        left:-$padding;
        top:-$padding;
        width:100%;
        height:100%;
      }
    }

  }

  &.togo-menu {
    width:5.5in;
    height:8.5in;
    max-width:5.5in;
    max-height:8.5in;
    min-width:0;
    padding:0;
    &.show-menu-overlay {
      border:1px solid blue;      
      &.drinks-menu {
        // background:url('~/static/togo-menu-drinks.png') no-repeat top left;
        // background-size:contain;
      }
      .menu-inner {
        background:rgba(aquamarine, .4);        
      }
    }
    .menu-inner {
      padding:.5in 0;
      &.togo {
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;    
      }      
    }

    .menu-inner-stretch {
      height:0px;
      width:100%;
    }      

    .menu-title-wrap {
      width:100%;
      display:flex;
      align-items:center;
      &:after {
        content : '';
        $scale : 3.1;
        $width : 160px / $scale;
        $height : 100px / $scale;
        background:url('../../../dist/citrus-segment.png') no-repeat center center;
        background-size:99%;
        // position:absolute;
        transform:rotate(-90deg) scaleX(-1);
        width:$width; 
        height:$height;
        margin-top:8px;
        // bottom:-$height - $borderWidth;
        // left:calc(50% - #{$width / 2});
        flex: 0 0 auto;
      }

      .menu-title {
        margin-bottom: 0;
        border-bottom:none;
        flex: 0 0 auto;
        font-size:3.8rem;
        padding-bottom:0;
        &:before {
          display:none;
        }
      }
    }

    .section-price-columns {
      margin-bottom:0;
      font-size:13px;
    }

    .section.has-subsections {
      .section-title-wrap .section-title {
        font-size:2.3rem;
      }
    }

    &:not(.drinks-menu) {
      .menu-inner {
        padding:.5in .5in 0;
      }

      .menu-col-right {
        flex:0 0 100%;
        padding:0 0 .25in;
      }
    }

  } // .togo-menu


} // .menu


.menu-col {
  padding-right:$gutter;
  padding-left:$gutter;
  flex:1 1 calc(100% - #{$gutter*2});
  box-sizing:content-box;
  @media (min-width:768px) {
    padding-bottom:4rem;
    flex:1 1 calc(50% - #{$gutter*2});
  }
}

.menu-col-left {
  position:relative;
  flex-wrap:wrap;
  .sections {
    flex:0 0 100%;
  }

  @media (min-width:768px) {
    flex:0 0 (100% * (4/12) );
  }  
}

.menu-title-wrap {
  @media (min-width:480px) {
    display:inline-block;
  }  
}


.menu-title {
  // display:inline-block;
  // white-space:nowrap;
  $borderWidth : 3px;
  font-weight:bold;
  font-size:6rem;
  border-bottom:$borderWidth solid black;
  margin-top:0;
  margin-bottom:10px;  
  padding-bottom:0.1em;
  line-height:0.82;
  text-transform:lowercase;
  font-family: 'Jaldi', sans-serif;
  word-break:break-all;
  position:relative;
  flex:0 0 100%;

  @media (min-width:768px) {
    margin-bottom:80px;    
    &:not(.empty-text):before {
      content : '';
      $scale : 1.7;
      $width : 160px / $scale;
      $height : 100px / $scale;
      background:url('../../../dist/citrus-segment.png') no-repeat center center;
      background-size:100%;
      position:absolute;
      width:$width; 
      height:$height;
      bottom:-$height - $borderWidth;
      left:calc(50% - #{$width / 2});
    }
  }
}

.menu-col-right {
  transition:background-color .3s ease;
  position:relative;
  @media (min-width:768px) {
    flex:0 0 calc(#{(100% * (7/12) )} - #{$gutter*2});
  }  

  &.empty{
    align-self: stretch;
    &:after {
      background-color:rgba(black, .05);
      content:'';
      position:absolute;
      $padding:10px;
      padding:$padding;
      left:-$padding;
      top:-$padding;
      width:100%;
      height:100%;
    }
  }
}

.section, .item {
  padding:($gutter / 2) 0;
}

.button-cluster {
  position:absolute;
  z-index:1000;
  bottom:0;
  right:0;
}

.add-element-button {
  position:absolute;
}


.dynamic-content[contenteditable="true"] {
  $activeBgColor : #00c2ff;
  outline:none;
  // &:before,
  &:after {
    background-color:$activeBgColor;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.spinner--wrap {
  margin-top:30px;
  margin-bottom:30px;
  height:100%;
}



</style>



// WEBPACK FOOTER //
// src/components/Location/LocationMenus.vue